import reduxCrud from 'redux-crud';

const driversReducers = reduxCrud.Map.reducersFor('drivers', { key: 'id' });

export default driversReducers;
